export const SportNames: Record<number, string> = {
    0: "All",
    1: "American Football",
    2: "Australian Rules",
    3: "Badminton",
    4: "Baseball",
    5: "Basketball",
    6: "Beach Soccer",
    7: "Beach Volleyball",
    8: "Bowls",
    9: "Boxing",
    10: "Chess",
    11: "Counter Strike",
    12: "Cricket",
    13: "Darts",
    14: "Dota",
    15: "E-Sports Basketball",
    16: "FIFA",
    17: "E-Sports Handball",
    18: "E-Sports Ice Hockey",
    19: "E-Sports Martial Arts",
    20: "E-Sports Tennis",
    21: "E-Sports Wrestling",
    22: "Football",
    23: "Futsal",
    24: "Golf",
    25: "Handball",
    26: "Ice Hockey",
    27: "Rugby",
    28: "Snooker",
    29: "Table Tennis",
    30: "Tennis",
    31: "Volleyball",
    32: "Water Polo",
    33: "World of Tanks",
    34: "Worms",
    35: "E-Sports",
    36: "E-Sports Cricket",
    37: "Mortal Kombat",
    38: "Martial Arts",
    39: "Rocket League",
    41: "E-Sports Rugby",
    42: "E-Sports American Football",
    43: "E-Sports Baseball",
    44: "E-Sports Lacrosse",
    45: "E-Sports Floorball",
    46: "PES",
    47: "Tekken",
    48: "E-Sports Table Tennis",
    49: "Playgrounds",
    50: "Pixel Cup Soccer",
    51: "E-Sports Australian Rules",
    63: "UFC",
    64: "Horse Racing",
    65: "Greyhound Racing",
    66: "Lottery"
  };
  